
































































import {Vue, Component, Watch} from 'vue-property-decorator';
import UserEdit from '@/components/UserEdit.vue';
import Table from '@/components/Table.vue';
import GenericButton from '@/components/GenericButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';
import ActionBarButton from '@/components/ActionBarButton.vue';
import CancelButton from '@/components/CancelButton.vue';
import Dialog from '@/components/Dialog.vue';
import SearchBar from '@/components/SearchBar.vue';
import {Getter} from 'vuex-class';
import RoleService from '@/services/role.service';
import AccountOrganisationAccess from '@/views/accounts/AccountOrganisationAccess.vue';
import {Organisation, Role} from '@/types';
import AccountService from '@/services/account.service';

@Component({
  components: {
    AccountOrganisationAccess,
    SearchBar, Dialog, CancelButton, ActionBarButton, ConfirmButton, GenericButton, Table, UserEdit},
})
export default class AccountAccess extends Vue {
  @Getter private hasPermission: any;
  @Getter private activeAccountId: any;
  private accountUserAddDialog: boolean = false;
  private saving: boolean = false;
  private clicked: any = { id: 0, title: 'Account Users', path: 'account-users' };
  private tab: string = '0';
  private menuItems: any = [
    { id: 0, title: 'Users', path: 'account-users' },
    { id: 0, title: 'API Keys', path: 'account-keys' },
  ];
  private newUser = {
    email: '',
    accountRoles: [],
    organisations: [],
  };

  private accountRoles: any = [];
  private orgRoles: any = [];
  private orgsToAdd: Organisation[] = [];
  private orgsToKeep: any[] = [];

  private async mounted() {
    const roles = await AccountService.getRoles(this.activeAccountId);
    this.accountRoles = roles.roles.filter((r: { context: string }) => r.context === 'account');
    this.orgRoles = roles.roles.filter((r: { context: string }) => r.context === 'organisation');
  }

  private async resetDialog() {
    this.orgsToKeep = [];
    this.orgsToAdd = [];
    this.accountUserAddDialog = false;
    this.newUser = {
      email: '',
      accountRoles: [],
      organisations: [],
    };
  }

  private search(search: string) {
    if (!this.$refs.accountUsers) {
      return;
    }
    (this.$refs.accountUsers as any).searchUsers(search);
  }

  private async saveUser() {
    this.saving = true;
    try {
      const currentOrgs = this.newUser.organisations || [];
      this.orgsToKeep = [...this.orgsToAdd, ...currentOrgs];
      const orgIdsWithRolesToKeep = this.orgsToKeep.flatMap((o: { id: number, roles: Role[] }) => {
        return o.roles.map((r: Role) =>  {
          return { organisationId: o.id, roleId: r.id };
        });
      });
      await AccountService.addAccountUser(this.activeAccountId, {
        user_email: this.newUser.email,
        accountRoleIds: this.newUser.accountRoles ? this.newUser.accountRoles.map((ar: Role) => ar.id) : [],
        organisationsWithRoles: orgIdsWithRolesToKeep,
      });
    } finally {
      await (this.$refs.accountUsers as any).getUsers();
      await this.resetDialog();
      this.saving = false;
    }
  }
}
